import { type RootState } from '@/state/store';

export const selectNotifications = (state: RootState) =>
  state.notifications.items;

export const selectUnreadCount = (state: RootState) =>
  state.notifications.unreadCount;

export const selectNotificationsLoading = (state: RootState) =>
  state.notifications.loading;

export const selectNotificationsPage = (state: RootState) =>
  state.notifications.page;

export const selectNotificationsHasMore = (state: RootState) =>
  state.notifications.page < state.notifications.lastPage;
